import React, { useState, useEffect } from "react";

// components 
import { CircularProgress, TextField } from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputSelect from "../partner/components/inputSelect";
import ModalMessage from "../modals/ModalMessage";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";

// styles
import useStyles from "./styles";
import useStylesTable from "./styles";
import config from "../../config";

export default function Purchase() {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [folio, setFolio] = useState({ text: '', valid: null });
  const [supplier, setSupplier] = useState({ text: '', valid: null });
  const [products, setProducts] = useState([]);
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const [dateOfPurchase, setDateOfPurchase] = useState('');
  const [currentDay, setCurrentDay] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [keyTable, setKeyTable] = useState(0);
  const [isProductExist, setIsProductExist] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [keyButton, setKeyButton] = useState(1);
  const [total, setTotal] = useState(0);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const closeModalMessage = e => {
    setShowModalMessage(false);
  }

  const fechGetProducts = async () => {
    fetch(baseUrl + "products",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error != null) {
          setShowModal(true);
        } else {
          setAllProducts(data);
        }
      })
      .catch(error => null);
  }

  const fetchSupplier = async () => {
    if (!showModal) {
      fetch(baseUrl + "supplier",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.status == null) {
            setAllSuppliers(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  useEffect(() => {
    fechGetProducts();
    fetchSupplier();
    getCurrentDay();
  }, []);

  const onSavePurchase = async e => {
    e.preventDefault();
    setIsLoading(true);
    var list = [];
    const date = new Date();
    var currentTime = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();

    products.map((item) => {
      list.push({
        productId: item.idProduct, productName: item.name, unitCost: item.cost, totalCost: Number(item.totalCost), quantity: Number(item.stock)
      });
    });

    const purchase = {
      creationTime: currentTime, dateOfPurchase: dateOfPurchase, subTotal: total, iva: 0, total: total, ticketFolio: folio.text,
      supplier: supplier.text, purchaseeProductList: list
    };

    const response = await fetch(baseUrl + "createPurchase", {
      method: 'POST',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      },
      body: JSON.stringify(purchase)
    });

    const json = await response.json();
    if (json.message == "Ok") {
      setFolio({ text: '', valid: null });
      setSupplier({ text: '', valid: null });
      setProducts([]);
      setAutocompleteKey(0);
      setDateOfPurchase('');
      setKeyTable(0);
      setIsProductExist(false);
      setKeyButton(1);
      setTotal(0);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      if (json.message == "Access is denied") {
        setShowModal(true);
      }
    }

    setIsLoading(false);
  }

  const calculatePrice = () => {
    var subTotal = 0;

    for (var i = 0; i < products.length; i++) {
      var item = products[i];
      subTotal = Number(subTotal) + Number(item.totalCost);
    }

    setTotal(Number(subTotal));
    setKeyButton(keyButton + 1);
  }

  const onDelete = (property) => (event) => {
    var indexProduct = -1;
    var subTotal = 0;

    products.map((item) => {
      if (item.id == property) {
        indexProduct = products.indexOf(item);
      }
    });

    if (indexProduct > -1) {
      if (products.length == 1) {
        setProducts([]);
      } else {
        setProducts(list);
        var list = [];
        products.map((item) => {
          if (item.id != property) {
            list.push(item);
          }
        });

        setProducts(list);
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          subTotal = Number(subTotal) + Number(item.totalCost);
        }
      }
      setKeyTable(keyTable + 1);
    }

    setTotal(Number(subTotal));
    setKeyButton(keyButton + 1);
  };

  const onTagsChange = (event, values) => {
    if (values != null) {
      var product = {
        "id": values.id,
        "idProduct": values.id,
        "name": values.name,
        "cost": null,
        "totalCost": 0,
        "stock": null
      };

      if (products.length > 0) {
        var existProduct = false;

        products.map((item) => {
          if (item.id == product.id) {
            existProduct = true;
          }
        });

        if (existProduct) {
          setIsProductExist(true);
          setShowModalMessage(true);
        } else {
          const allList = products;
          allList.push(product);
          setProducts(allList);
        }
      } else {
        const allList = products;
        allList.push(product);
        setProducts(allList);
      }
    }

    setAutocompleteKey(autocompleteKey + 1);
    setKeyButton(keyButton + 1);
  }

  const handleFolio = (event) => {
    if (event.target.value != '') {
      setFolio({ text: event.target.value, valid: 'true' });
    } else {
      setFolio({ text: '', valid: 'false' });
    }
  }

  const onChangeDatePicker = (e) => {
    setDateOfPurchase(e.target.value);
  }

  function getCurrentDay() {
    var today = new Date();
    var day = today.getDate();

    if (today.getDate() < 10) {
      day = "0" + today.getDate();
    }

    setCurrentDay(today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + day);
    setDateOfPurchase(today.getFullYear() + "-" + today.getMonth() + "-" + day);
  }

  const onChangeQuantity = (property) => (event) => {
    var value = event.target.value;

    for (var i = 0; i < products.length; i++) {
      var item = products[i];
      var indexProduct = products.indexOf(item);

      if (item.id == property) {
        var product;

        if (item.cost != null) {
          product = {
            "id": item.id,
            "idProduct": item.id,
            "name": item.name,
            "cost": item.cost,
            "totalCost": (parseFloat(value) * parseFloat(item.cost)).toFixed(2),
            "stock": value,
          }
        } else {
          product = {
            "id": item.id,
            "idProduct": item.id,
            "name": item.name,
            "cost": item.cost,
            "totalCost": item.totalCost,
            "stock": value,
          }
        }

        const allList = products;
        allList[indexProduct] = product;
        setProducts(allList);
        i = products.length;
      }
    }

    setKeyButton(keyButton + 1);
    calculatePrice();
  }

  const onChangeCost = (property) => (event) => {
    var value = event.target.value;

    if (value == "") {
      value = 0;
    }

    for (var i = 0; i < products.length; i++) {
      var item = products[i];
      var indexProduct = products.indexOf(item);

      if (item.id == property) {
        var product = {
          "id": item.id,
          "idProduct": item.id,
          "name": item.name,
          "cost": Number(value),
          "totalCost": (parseFloat(item.stock) * parseFloat(value)).toFixed(2),
          "stock": item.stock,
        }

        const allList = products;
        allList[indexProduct] = product;
        setProducts(allList);
        i = products.length;
      }
    }

    setKeyButton(keyButton + 1);
    calculatePrice();
  }

  return (
    <>
      {isProductExist ? (
        <ModalMessage
          isOpen={showModalMessage}
          closeModal={closeModalMessage}
        />
      ) : (
        <></>
      )}

      <div>
        <div className={classes.divHeader} >
          <div style={{ width: "20%" }}>
            <InputSelect
              text={supplier}
              setValue={setSupplier}
              label={"Proveedor"}
              options={allSuppliers}
              isRequired={true}
            />
          </div>

          <div style={{ display: "flex", justify: "center", alignItems: "center" }}>
            <p style={{ marginLeft: "50px", marginRight: "12px", fontSize: "16px" }}>Folio</p>
            <div style={{
              backgroundColor: "#FFFFFF",
              padding: '6px',
              display: 'flex',
              justify: 'center',
              alignItems: 'center',
              borderRadius: '100px',
            }} >
              <input
                style={{
                  border: '0px',
                  backgroundColor: "#FFFFFF",
                  borderRadius: '100px',
                  padding: '10px',
                  outlineColor: "#FFFFFF",
                  fontSize: "16px"
                }}
                value={folio.text}
                type="text"
                onChange={(event) => handleFolio(event)}
                placeholder={"0000"}
                name={"folio"}
              />
            </div>
          </div>

          <div style={{ display: "flex", justify: "center", alignItems: "center" }}>
            <p style={{ marginLeft: "50px", marginRight: "12px", fontSize: "16px" }}>Fecha de compra</p>
            <div style={{
              backgroundColor: "#FFFFFF",
              padding: '6px',
              display: 'flex',
              justify: 'center',
              alignItems: 'center',
              borderRadius: '100px',
            }} >
              <input
                style={{
                  border: '0px',
                  backgroundColor: "#FFFFFF",
                  borderRadius: '100px',
                  padding: '10px',
                  outlineColor: "#FFFFFF",
                  fontSize: "16px"
                }}
                type="date"
                defaultValue={currentDay}
                onChange={onChangeDatePicker}
                name={"dateOfPurchase"}
              />
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", marginTop: "50px" }}>
        <div className={classes.div} >
          <Autocomplete
            key={autocompleteKey}
            options={allProducts}
            freeSolo
            getOptionLabel={option => option.name}
            onChange={onTagsChange}
            openText={"Abrir"}
            closeText={"Cerrar"}
            clearText={"Limpiar"}
            noOptionsText={"Sin resultados"}
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                placeholder={"Buscar producto"}
                style={{
                  border: '0px',
                  backgroundColor: "#FFFFFF",
                  borderRadius: '100px',
                  marginLeft: '8px',
                  width: '350px',
                  outlineColor: "#FFFFFF",
                }}
              />
            )}
          />
          <div className={classes.divSearch} >
            <Icons.Search classes={{ root: classes.searchIconProduct }} />
          </div>
        </div>
      </div>

      <div style={{ marginTop: "60px" }}></div>
      <div className={classesTable.divCard} >
        <Table className="mb-0" key={keyTable}>
          <TableHead>
            <TableRow className={classesTable.root} >
              <TableCell>NOMBRE</TableCell>
              <TableCell>CANTIDAD</TableCell>
              <TableCell>PRECIO SIN I.V.A.</TableCell>
              <TableCell>IMPORTE</TableCell>
              <TableCell>ACCIÓN</TableCell>
              {/*{keys.map(key => (
                    <TableCell key={key}>{key}</TableCell>
                  ))}*/}
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map(({ id, name, cost, totalCost, stock }) => (
              <TableRow key={id}>
                <TableCell className={classesTable.tableTextStyle} >{name}</TableCell>
                <TableCell className={classesTable.tableTextStyle} >
                  <TextField
                    InputProps={{
                      classes: {
                        focused: classes.textBorderMembership,
                        input: classes.inputNumberPurchase,
                      },
                      inputProps: {
                        min: 0
                      }
                    }}
                    value={stock}
                    onChange={onChangeQuantity(id)}
                    placeholder={"1"}
                    type={"number"}
                    onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                    style={{ width: '70%' }}
                    inputStyle={{ width: '70%' }}
                  />
                </TableCell>
                <TableCell className={classesTable.tableTextStyle} >
                  <div style={{ display: "flex" }}>
                    <p style={{ fontSize: "16px", marginTop: "8px" }}> $ </p>
                    <TextField
                      InputProps={{
                        classes: {
                          focused: classes.textBorderMembership,
                          input: classes.inputNumberPurchase,
                        },
                        inputProps: {
                          min: 0
                        }
                      }}
                      value={cost}
                      onChange={onChangeCost(id)}
                      placeholder={"1"}
                      type={"number"}
                      onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                      style={{ width: '70%' }}
                      inputStyle={{ width: '70%' }}
                    />
                  </div>
                </TableCell>
                <TableCell className={classesTable.tableTextStyle} > {"$ " + Number(totalCost).toFixed(2)} </TableCell>
                <TableCell className={classesTable.tableTextStyle} >
                  <div className={classesTable.divActionButton}>
                    <Delete className={classesTable.iconAcctionInventory}
                      onClick={onDelete(id)}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div style={{ width: "25%", float: "right", marginTop: "30px", marginBottom: "60px" }}>
        <div className={classesTable.divCard} >
          <div>
            <div style={{ display: "flex" }}>
              <text style={{ fontSize: "16px" }} >{"Total:"}</text>
              <text className={classes.textPurchase}> {"$ " + Number(total).toFixed(2)} </text>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.divButton}>
        {isLoading ? (
          <div className={classes.loginLoader} >
            <CircularProgress size={26} />
          </div>
        ) : (
          <button
            key={keyButton}
            className={products.length > 0 && supplier.text != "" ?
              classes.enableButton : classes.disableButton}
            disabled={!(products.length > 0 && supplier.text != "")}
            onClick={onSavePurchase}
          >GUARDAR</button>
        )}
      </div>
    </>
  );
}
